module.exports = __webpack_public_path__ + "img/logodu.9f26f5b8.png";